<script>
export default {
  translate25Context: "branding",
  components: {},
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {},
};
</script>

<template>
  <div class="branding-component">
    <f-form>
      <template #title>
        <f-icon icon="fa6-building"></f-icon>{{ $vt("Branding") }}
      </template>
      <template #content>

        <vue-placeholder :component="component.logo" :handler="handler"></vue-placeholder>
        <vue-placeholder :component="component.background" :handler="handler"></vue-placeholder>

        <vue-placeholder :component="component.title" :handler="handler"></vue-placeholder>
        <vue-placeholder :component="component.link" :handler="handler"></vue-placeholder>

        <vue-placeholder :component="component.first_color" :handler="handler"></vue-placeholder>
        <vue-placeholder :component="component.second_color" :handler="handler"></vue-placeholder>

      </template>
    </f-form>
  </div>
</template>

<style lang="scss">
.branding-component {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 45px 0;
  height: 100%;
  > .f-form {
    width: 500px;
    flex: 1 1 auto;

    .f-form {
      > .title {
        color: var(--white-a25);
        padding: 0;
      }

      > .content-container {
        margin-top: 16px;

        .content {
          margin: 0;
          padding: 0;
        }
      }
    }
  }
}
</style>